import { Swiper, Navigation, Pagination, Autoplay, Lazy } from 'swiper';

// Install modules
Swiper.use([Navigation, Pagination, Autoplay, Lazy]);

export default Swiper;
